export default __webpack_public_path__ + "assets/workingHoursIcon.659c2e4b.png";